import { useState, useEffect } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CodeInput from '../components/CodeInput';
import { useAppContext } from '../AppContext';
import { useNavigate } from 'react-router-dom';
import { CODE_API_BASE_URL } from '../constants';
import Footer from '../components/Footer';
import { ROUTES } from '../routes/routeConstants';
import { useDevHub } from '../context/devhub/useDevHubSDK.js';
import './ClaimCard.css';

const question = require('../assets/question_2x.png');

const ClaimCard = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isClaimed, setIsClaimed] = useState(false);
  const [isCodeComplete, setIsCodeComplete] = useState(false);
  const [redeemedCode, setRedeemedCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { pasteCodeResult, userProfile } = useAppContext();

  const { devHubUser } = useDevHub();  

  useEffect(() => {
    console.log('ClaimCard', '1', userProfile.userId);
    setIsLoading(true);
    const getRedeemedCodesByUser = async () => {
      if (!userProfile.userId) {
        navigate(ROUTES.ROOT);
      }
      const url = `${CODE_API_BASE_URL}/codes/redeemedBy/${userProfile.userId}`;
      console.log("userId", userProfile.userId);
      const result = await fetch(url, {
        headers: {
          'accept': 'application/json',
          'Authorization': window.nbc.identity.token
        }
      });
      // Check if the user already has the medallion
      // If so, redirect to collection page
      let codes = await result.json();
      console.log("get redeemed codes >>>", codes);
      if (codes.length > 0) {
        navigate(ROUTES.COLLECTION);
        return;
      }
      setIsLoading(false);
    };

    getRedeemedCodesByUser();

  }, [userProfile]);

  const handleCodeComplete = (code) => {
    setIsCodeComplete(true);
    setRedeemedCode(code);
  };
  
  const getRedeemedCodes = async () => {
    const url = `${CODE_API_BASE_URL}/codes/${redeemedCode}`;
    const result = await fetch(url, { headers: { 'accept': 'application/json' } });
    const json = await result.json();
    console.log("get redeemed codes >>>", json);
    const redeemed = {};
    if (!result.ok) {
      console.log("error redeeming code", pasteCodeResult);
      return;
    }

    navigate(ROUTES.COLLECTION);
    return;
  };

  const handleClaimCard = async (code) => {
    if (!code) return;
    console.log(code);
    const userId = window.nbc  && window.nbc.identity && window.nbc.identity.profile
      ? window.nbc.identity.profile._id : "";
    if (!userId) {
      navigate(ROUTES.ROOT);
      return;
    }

    let someCondition = false;

    // async function waitForTrue() {
      // console.log('waiting... for wallet address', devHubUser?.address)
      // while (true) {
        // if (devHubUser?.address && devHubUser?.address.length > 0) {
        //   return true;
        // }
        // await new Promise(resolve => setTimeout(resolve, 1000)); // wait 1 second
      // }
    // }
    // await waitForTrue();

    const result = await fetch(`${CODE_API_BASE_URL}/codes/${code}/redeem`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': window.nbc.identity.token
      },
      body: JSON.stringify({
        redeemed_by: userId
      })
    });

    window.nbc.identity.analyticsEventLogger.setMParticleUserAttribute("epicgo.claim_code", code);

    if (!result.ok) {
      const msg = await result.json();
      console.log("ERROR: >>>", msg);
      if (msg.errorMsg == "Invalid Code.") {
        setErrorMessage("This code has already been redeemed.");
      }
      else {
        setErrorMessage("Invalid code, please try again.");
      }
      return;
    }

    const json = await result.json();
    console.log('redeemed', json);

    setIsClaimed(true);
    await getRedeemedCodes();
  };

  return (
    <div>
      <Box className="claim-page background">
        <img src={question} width={isSmallScreen ? 200 : 300} style={{
          display: 'block',
          margin: isSmallScreen ? '40px auto 15px auto' : '45px auto 15px auto',
          }} alt="Mystery medallion"
        />
        <Box style={{ width: isSmallScreen ? '350px' : '500px', margin: '0 auto', display: 'block' }}>
          <p style={{ color: 'rgb(210 172 86)', fontWeight: 300, fontSize: '1rem', textTransform: 'uppercase' }}>
            Enter your unique code
          </p>
          <h2 style={{
            color: '#fff',
            fontWeight: 600,
            textAlign: 'center',
            lineHeight: '48px',
            fontSize: '20px',
            maxWidth: 780,
            display: 'block',
            margin: '30px auto -8px auto',
            letterSpacing: 2
          }}>
            UNIVERSAL EPIC UNIVERSE
          </h2>
          <h2 style={{
            color: '#fff',
            fontWeight: 600,
            textAlign: 'center',
            lineHeight: '38px',
            fontSize: isSmallScreen ? '36px' : '38px',
            width: '80%',
            maxWidth: 780,
            display: 'block',
            margin: '0 auto',
            letterSpacing: 0
          }}>
            Grand Opening Day Digital Medallion
          </h2>
          {/* <p style={{ color: '#fff', fontWeight: 300, fontSize: '1.2rem' }}>
            Universal Epic Universe Grand Opening Day Digital Medallion
          </p> */}
          <CodeInput length={6} onComplete={handleCodeComplete} onSubmit={handleClaimCard} errorMessage={errorMessage}/>
          <button onClick={() => navigate(ROUTES.HOME)} style={{
            background: '#000000',
            border: '2px solid #f7d58e',
            color: '#ffffff',
            width: '100%',
            marginBottom: 70
          }}>
            Go Back
          </button>
          {/* {errorMessage && <p style={{ color: 'white', textAlign: 'center' }}>{errorMessage} </p>} */}
        </Box>
      </Box>
    <Footer />
  </div>
);};

export default ClaimCard;